import {Helmet} from "react-helmet";
import {RouteHelper, RouteInfo} from "../../route/RouteHelper";
import {
    RaikoBaseContainer,
    RaikoGridOneColumn,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoBaseCardContainer,
    RaikoTableTitleContainer,
    RaikoCustomTable,
    RaikoCustomSimpleChip,
    RaikoChipTypes,
    showErrorMessage,
    RaikoSectionContainer,
    RaikoGridThreeColumn,
    RaikoSimpleInputOutlined,
    RaikoMobileInputOutlined,
    RaikoDefaultDialogPage,
    DialogSize
} from "@moeindal/base-raiko-panel-components"
import {css} from "@emotion/css";
import React, {useEffect, useState} from "react";
import {ContactUsService} from "../../serverService/contactUsService/ContactUsService";
import {convertUniversalDateToPersianDate} from "../../util/DateConvertor";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {useDebounce} from "@uidotdev/usehooks";
import ShowMessageInfo from "./ShowMessageInfo";

export default function ContactUs() {


    const [numberOfItem, setNumberOfItem] = useState(0);
    const [messageData, setMessageData] = useState([]);
    const [page, setPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [tableLoading, setTableLoading] = useState(false);
    const [fullName, setFullName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [email, setEmail] = useState("");
    const [messageId, setMessageId] = useState(-1);
    const [refresh, setRefresh] = useState(false)

    const fullNameFilter = useDebounce(fullName, 500);
    const phoneNumberFilter = useDebounce(phoneNumber, 500);
    const emailFilter = useDebounce(email, 500);


    let size = 20;


    const service = new ContactUsService()

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getMessageFromServer()
        }
    }, [fullNameFilter, phoneNumberFilter, emailFilter]);

    function tableContactUsPreparation(id, number, fullName, email, title, description, sendAt, phoneNumber, status) {
        return {
            id: id,
            number: number,
            title: title,
            fullName: fullName ? fullName : "-",
            email: email,
            description: description,
            sendAt: convertUniversalDateToPersianDate(sendAt),
            phoneNumber: phoneNumber,
            status: status === "REVIEWED" ? <RaikoCustomSimpleChip title={"بررسی شده"} type={RaikoChipTypes.success}/> :
                <RaikoCustomSimpleChip title={"در حال بررسی"} type={RaikoChipTypes.error}/>
        }

    }

    function getMessageFromServer() {
        setTableLoading(true)
        service.getContactUsList(page, size, fullNameFilter, phoneNumberFilter, emailFilter).then(
            response => {
                setNumberOfItem(response.numberOfItems)
                setPageCount(response.totalPage)
                setMessageData([])
                response.data.map((item, index) => {
                    setMessageData((prevState => [
                        ...prevState,
                        tableContactUsPreparation(
                            item.id,
                            (page * size) + index + 1,
                            item.firstName ? `${item.firstName}` : "-",
                            item.email,
                            item.title,
                            item.description,
                            item.sendAt,
                            item.phoneNumber,
                            item.status
                        )
                    ]))
                })
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setTableLoading(false)
        })
    }

    //showMessage
    const [openDialogState, setOpenDialogState] = useState(false)

    function handleOpenDialog() {
        setOpenDialogState(true)
    }

    function handleCloseDialog() {
        setOpenDialogState(false)
        setMessageId(-1)
        if (refresh) {
            getMessageFromServer()
        }
    }

    function showMessage(rowId) {
        setMessageId(rowId)
        setOpenDialogState(true)
    }

    //showMessage


    return (
        <>
            <Helmet>
                <title>
                    {RouteHelper.ContactUs.name}
                </title>
            </Helmet>
            <RaikoDefaultDialogPage
                pageTitle={"جزئیات پیام"}
                open={openDialogState}
                dialogSize={DialogSize.MEDIUM}
                onClose={handleCloseDialog}
            >
                <ShowMessageInfo messageId={messageId} setRefresh={setRefresh} handleCloseDialog={handleCloseDialog }/>
            </RaikoDefaultDialogPage>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                    <RaikoBreadcrumb
                        breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(RouteHelper.ContactUs.name, "")
                        ]}
                    />
                    <RaikoBaseCardContainer>
                        <RaikoSectionContainer
                            title={"جستجو"}
                            subTitle={"برای جستجو عبارت مورد نظر خود را وارد نمایید."}
                        >
                            <RaikoGridThreeColumn>
                                <RaikoSimpleInputOutlined
                                    labelText={"نام و نام خانوادگی"}
                                    setValue={setFullName}
                                    value={fullName}/>
                                <RaikoMobileInputOutlined
                                    labelText={"شماره همراه"}
                                    setValue={setPhoneNumber}
                                    value={phoneNumber}/>
                                <RaikoSimpleInputOutlined
                                    labelText={"ایمیل"}
                                    setValue={setEmail}
                                    value={email}/>
                            </RaikoGridThreeColumn>
                        </RaikoSectionContainer>
                    </RaikoBaseCardContainer>
                    <RaikoBaseCardContainer>
                        <RaikoGridOneColumn>
                            <RaikoTableTitleContainer
                                title={"تماس با ما"}
                                amount={numberOfItem}
                            />
                            <RaikoCustomTable
                                data={messageData}
                                header={columns}
                                pageCount={pageCount}
                                isLoading={tableLoading}
                                rowClicked={showMessage}
                            />
                        </RaikoGridOneColumn>
                    </RaikoBaseCardContainer>

                </RaikoGridOneColumn>
            </RaikoBaseContainer>
        </>
    )
}
const columns = [
    {
        id: 'number',
        label: '#',
    },
    {
        id: 'title',
        label: 'عنوان',

    },
    {
        id: 'fullName',
        label: 'نام و نام خانوادگی',

    },
    {
        id: 'phoneNumber',
        label: 'شماره همراه',

    },
    {
        id: 'email',
        label: 'ایمیل',

    },
    {
        id: 'sendAt',
        label: 'تاریخ ارسال',

    },
    {
        id: 'status',
        label: 'وضعیت',
    },
];